var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolyline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3485_29754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.41395 18.1634L2.2915 12.7213L13.516 1.83691L18.9582 12.7213L8.41395 18.1634Z",
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75448 16.4625L4.67285 12.721L13.0235 4.59229L16.9177 12.0407L8.75448 16.4625Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.33317,
    cy: 12.5002,
    rx: 1.66667,
    ry: 1.66667,
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.33317,
    cy: 17.5002,
    rx: 1.66667,
    ry: 1.66667,
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.3332,
    cy: 12.5002,
    r: 1.66667,
    fill: "#888888"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3332,
    cy: 3.33317,
    rx: 1.66667,
    ry: 1.66667,
    fill: "#888888"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3485_29754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolyline);
export default __webpack_public_path__ + "static/media/polyline.9aaa234e2b4b79bdf10f22c8ee1ade26.svg";
export { ForwardRef as ReactComponent };